
import Dropdown from '../dropdown';
import List from '../list';
import ListItem from '../list-item';
import Checkbox from '../checkbox';
import SelectOptionsMixin from '../../mixins/select-options';
import MultiSelectProps from './mixins/MultiSelectProps';
import MultiSelectEvents from './mixins/MultiSelectEvents';
import { MultiSelectProperty } from './enums';

export default {
  name: 'MultiSelect',
  components: {
    Dropdown,
    List,
    ListItem,
    Checkbox,
  },
  mixins: [SelectOptionsMixin, MultiSelectProps, MultiSelectEvents],
  data() {
    return {
      MultiSelectProperty,
    };
  },
};
